<template>
  <div class="py-2 px-6">
    <h2 class="text-lg py-2 font-medium">
      Uge {{ currentWeek }}
    </h2>

    <div class="py-2" v-if="state === 'FREE'">
      <div class="text-sm text-gray-800">Der er ingen mobiliseringer i denne uge.</div>
    </div>

    <div class="py-2" v-if="state !== 'FREE'">
      <label for="boarding_days" class="block text-sm font-medium leading-6 text-secondary">
        Kost
      </label>
      <div>
        <input id="distance_registered" v-model="boardingDays" name="boarding_days" type="number" inputmode="numeric"
          placeholder="Antal hele døgn"
          class="peer block w-full rounded-md border-0 pb-1.5 pt-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6 font-medium" />
        <span class="m-2 hidden text-sm text-error peer-[&:not(:focus):invalid]:block">Angiv en gyldig værdi</span>
      </div>
    </div>

    <div class="py-2" v-if="state !== 'FREE'">
      <label for="lodging_days" class="block text-sm font-medium leading-6 text-secondary">
        Logi
      </label>
      <div>
        <input id="distance_registered" v-model="lodgingDays" name="lodging_days" type="number" inputmode="numeric"
          placeholder="Antal hele døgn"
          class="peer block w-full rounded-md border-0 pb-1.5 pt-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6 font-medium" />
        <span class="m-2 hidden text-sm text-error peer-[&:not(:focus):invalid]:block">Angiv en gyldig værdi</span>
      </div>
    </div>

    <div class="py-2" v-if="state !== 'FREE'">
      <label for="connecting_hours" class="block text-sm font-medium leading-6 text-secondary">
        Tilsluttende timer
      </label>
      <div>
        <input id="distance_registered" v-model="connectingHours" name="connecting_hourss" type="number" step="0.1" inputmode="numeric"
          placeholder="Antal timer"
          class="peer block w-full rounded-md border-0 pb-1.5 pt-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6 font-medium" />
        <span class="m-2 hidden text-sm text-error peer-[&:not(:focus):invalid]:block">Angiv en gyldig værdi</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { getWeekNumber } from '@/core/utils'
import { DietReport } from '@/models/report.model'
import { defineComponent, nextTick, onBeforeMount, onMounted, ref, watch } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'diet-selection',
  setup () {
    const store = useStore()
    const currentWeek = getWeekNumber(new Date())
    const year = new Date().getFullYear()
    const boardingDays = ref<undefined | number>(undefined)
    const lodgingDays = ref<undefined | number>(undefined)
    const connectingHours = ref<undefined | number>(undefined)
    const state = ref<undefined | string>(undefined)

    store.commit('report/UPDATE_REPORT', { key: 'weekNumber', value: currentWeek })

    let timeoutId: number | undefined

    onBeforeMount(() => {
      store.dispatch('report/fetchDietReportDetails', { weekNumber: currentWeek, year })
    })

    watch(() => store.state.report.currentReport, (val) => {
      boardingDays.value = val.daysAmountBoarding
      lodgingDays.value = val.daysAmountLodging
      connectingHours.value = val.amountConnectingHours
      state.value = val.state
    }, {
      immediate: true
    })

    watch(boardingDays, (newVal: number | undefined) => {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
      timeoutId = setTimeout(() => {
        store.commit('report/UPDATE_REPORT', { key: 'daysAmountBoarding', value: newVal })
      }, 300)
    })

    watch(lodgingDays, (newVal: number | undefined) => {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
      timeoutId = setTimeout(() => {
        if (newVal !== undefined) {
          store.commit('report/UPDATE_REPORT', { key: 'daysAmountLodging', value: newVal })
        }
      }, 300)
    })

    watch(connectingHours, (newVal: number | undefined) => {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
      timeoutId = setTimeout(() => {
        if (newVal !== undefined) {
          store.commit('report/UPDATE_REPORT', { key: 'amountConnectingHours', value: newVal })
        }
      }, 300)
    })

    return { currentWeek, boardingDays, lodgingDays, connectingHours, state }
  }
})
</script>
